export const DASHBOARD = "/dashboard";

export const DASHBOARD_FARM = DASHBOARD + "/farm";
export const DASHBOARD_PRODUCE_DETAIL = DASHBOARD_FARM + "/produce/:id";

export const DASHBOARD_MARKET = DASHBOARD + "/market";
export const DASHBOARD_MARKET_DETAIL = DASHBOARD_MARKET + "/produce/:id";

export const DASHBOARD_BIDS = DASHBOARD + "/bids";
export const DASHBOARD_STATISTICS = DASHBOARD + "/statistics";
export const DASHBOARD_ADD_PRODUCT = DASHBOARD + "/add-product";

export const ADD_FARM = "/farm/add";
